import { render, staticRenderFns } from "./VSticky.vue?vue&type=template&id=7bd112ad"
import script from "./VSticky.vue?vue&type=script&lang=js"
export * from "./VSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports